import { Component, inject, OnInit, signal } from '@angular/core';
import { NextFormService } from '../../services/next-form.service';
import FormService from '../forms.service';
import { RouterModule } from '@angular/router';
import { catchError, combineLatest, forkJoin, map, Observable, of, switchMap, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Layout } from '../../layout/layout';
import CurrentFormService from '../current_form.service';

@Component({
  selector: 'app-success',
  imports: [RouterModule, CommonModule, Layout],
  templateUrl: './success.html',
})
export class Success implements OnInit {
  protected currentFormService = inject(CurrentFormService);
  private nextFormService = inject(NextFormService);
  ngOnInit(): void {
    if (this.currentFormService.definition()) {
      this.nextFormService.done(this.currentFormService.definition()!._id);
    }

    this.nextFormService.nextForms.subscribe({
      next: (res) => {
        this.nextForms.set(res);
      },
    });
  }
  nextForms = signal<{ _id: string; name: string }[]>([]);

  removeSavedForms() {
    this.nextFormService.reset();
  }
}
